import CarPage from './CarPage'

export default CarPage
